// 通用 const 数据集中管理

// platform
const platformData = [
  { name: '亚马逊', id: 1 },
  { name: '速卖通', id: 2 },
  { name: 'wish', id: 3 },
  { name: 'shopee', id: 4 },
  { name: 'shopify', id: 5 },
  { name: 'lazada', id: 6 },
  { name: 'etsy', id: 7 },
  { name: '店匠', id: 8 },
  { name: 'shopline', id: 9 },
  { name: '其他', id: 99 }
]
const platformAll = [
  { name: '全部', id: '' },
  { name: '亚马逊', id: 1 },
  { name: '速卖通', id: 2 },
  { name: 'wish', id: 3 },
  { name: 'shopee', id: 4 },
  { name: 'shopify', id: 5 },
  { name: 'lazada', id: 6 },
  { name: 'etsy', id: 7 },
  { name: '店匠', id: 8 },
  { name: 'shopline', id: 9 },
  { name: '其他', id: 99 }
]

const platformName = {
  1: {
    name: '亚马逊',
    value: 1
  },
  2: {
    name: '速卖通',
    value: 2
  },
  3: {
    name: 'wish',
    value: 3
  },
  4: {
    name: 'shopee',
    value: 4
  },
  5: {
    name: 'shopify',
    value: 5
  },
  6: {
    name: 'lazada',
    value: 6
  },
  7: {
    name: 'etsy',
    value: 7
  },
  8: {
    name: '店匠',
    value: 8
  },
  9: {
    name: 'shopline',
    value: 9
  },
  99: {
    name: '其他',
    value: 99
  }
}

const platformMenu = [
  { name: 'shopify', id: 5, children: [] },
  { name: '亚马逊', id: 1, children: [] },
  { name: '速卖通', id: 2, children: [] },
  { name: 'wish', id: 3, children: [] },
  { name: 'shopee', id: 4, children: [] },
  { name: 'lazada', id: 6, children: [] },
  { name: 'etsy', id: 7, children: [] },
  { name: '店匠', id: 8, children: [] },
  { name: 'shopline', id: 9, children: [] },
  { name: '其他', id: 99, children: [] }
]
const languageData = {
  0: 'Chinese',
  1: 'English',
  2: 'Japanese'
}
const languageKey = ['name', 'name_en', 'name_jp']
const keyCodeData = {
  8: 'BackSpace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Ctrl',
  18: 'Alt',
  19: 'Pause',
  20: 'Caps_Lock',
  27: 'Escape',
  32: 'Space',
  33: 'Prior',
  34: 'Next',
  35: 'End',
  36: 'Home',
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  41: 'Select',
  42: 'Print',
  43: 'Execute',
  45: 'Insert',
  46: 'Delete',
  47: 'Help',
  48: '0',
  49: '1',
  50: '2',
  51: '3',
  52: '4',
  53: '5',
  54: '6',
  55: '7',
  56: '8',
  57: '9',
  65: 'A',
  66: 'B',
  67: 'C',
  68: 'D',
  69: 'E',
  70: 'F',
  71: 'G',
  72: 'H',
  73: 'I',
  74: 'J',
  75: 'K',
  76: 'L',
  77: 'M',
  78: 'N',
  79: 'O',
  80: 'P',
  81: 'Q',
  82: 'R',
  83: 'S',
  84: 'T',
  85: 'U',
  86: 'V',
  87: 'W',
  88: 'X',
  89: 'Y',
  90: 'Z',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  999: 'Process'
}
const whenMade = [
  'made_to_order',
  '2020_2021',
  '2010_2019',
  '2002_2009',
  'before_2002',
  '2000_2001',
  '1990s',
  '1980s',
  '1970s',
  '1960s',
  '1950s',
  '1940s',
  '1930s',
  '1920s',
  '1910s',
  '1900s',
  '1800s',
  '1700s',
  'before_1700'
]
const thirdProductUnit = [
  {
    name: '袋 (bag/bags)',
    id: 100000000
  },
  {
    name: '桶 (barrel/barrels)',
    id: 100000001
  },
  {
    name: '蒲式耳 (bushel/bushels)',
    id: 100000002
  },
  {
    name: '箱 (carton)100078581',
    id: 100078580
  },
  {
    name: '厘米 (centimeter)',
    id: 100078581
  },
  {
    name: '立方米 (cubic meter)',
    id: 100000003
  },
  {
    name: '打 (dozen)',
    id: 100000004
  },
  {
    name: '英尺 (feet)',
    id: 100078584
  },
  {
    name: '加仑 (gallon)',
    id: 100000005
  },
  {
    name: '克 (gram)',
    id: 100000006
  },
  {
    name: '英寸 (inch)',
    id: 100078587
  },
  {
    name: '千克 (kilogram)',
    id: 100000007
  },
  {
    name: '千升 (kiloliter)',
    id: 100078589
  },
  {
    name: '千米 (kilometer)',
    id: 100000008
  },
  {
    name: '升',
    id: 100078559
  },
  {
    name: '英吨 (long ton)',
    id: 100000009
  },
  {
    name: '米 (meter)',
    id: 100000010
  },
  {
    name: '公吨 (metric ton)',
    id: 100000011
  },
  {
    name: '毫克 (milligram)',
    id: 100078560
  },
  {
    name: '毫升 (milliliter)',
    id: 100078596
  },
  {
    name: '毫米 (millimeter)',
    id: 100078597
  },
  {
    name: '盎司 (ounce)',
    id: 100000012
  },
  {
    name: '包 (pack/packs)',
    id: 100000014
  },
  {
    name: '双 (pair)',
    id: 100000013
  },
  {
    name: '件/个 (piece/pieces)',
    id: 100000015
  },
  {
    name: '磅 (pound)',
    id: 100000016
  },
  {
    name: '夸脱 (quart)',
    id: 100078603
  },
  {
    name: '套 (set/sets)',
    id: 100000017
  },
  {
    name: '美吨 (short ton)',
    id: 100000018
  },
  {
    name: '平方英尺 (square feet)',
    id: 100078606
  },
  {
    name: '平方英寸 (square inch)',
    id: 100078607
  },
  {
    name: '平方米 (square meter)',
    id: 100000019
  },
  {
    name: '平方码 (square yard)',
    id: 100078609
  },
  {
    name: '吨 (ton)',
    id: 100000020
  },
  {
    name: '码 (yard/yards)',
    id: 100078558
  }
]

const mapChinese = {
  '<show_image_1>': '效果图1',
  '<show_image_2>': '效果图2',
  '<show_image_3>': '效果图3',
  '<show_image_4>': '效果图4',
  '<show_image_5>': '效果图5',
  '<show_image_6>': '效果图6',
  '<show_image_7>': '效果图7',
  '<show_image_8>': '效果图8',
  '<show_image_9>': '效果图9',
  '<show_image_10>': '效果图10',
  '<user_show_image_1>': '独有底板1',
  '<user_show_image_2>': '独有底板2',
  '<user_show_image_3>': '独有底板3',
  '<user_show_image_4>': '独有底板4',
  '<user_show_image_5>': '独有底板5',
  '<user_show_image_6>': '独有底板6',
  '<user_show_image_7>': '独有底板7',
  '<user_show_image_8>': '独有底板8'
}

// 适用平台
const applyPlatform = [
  { name: '独立站', id: 100 },
  { name: '亚马逊', id: 1 },
  { name: '速卖通', id: 2 },
  { name: 'wish', id: 3 },
  { name: 'shopee', id: 4 },
  { name: 'lazada', id: 6 },
  { name: 'etsy', id: 7 }
]

//
const qualityLevel = [
  { name: '全部', id: '' },
  { name: '优质', id: 1 },
  { name: '标准', id: 2 },
  { name: '经济', id: 3 }
]

const curList = [
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'CNY', value: 'CNY' },
  { label: 'EUR', value: 'EUR' },
  { label: 'AUD', value: 'AUD' },
  { label: 'JPY', value: 'JPY' },
  { label: 'KRW', value: 'KRW' },
  { label: 'HKD', value: 'HKD' },
  { label: 'SGD', value: 'SGD' },
  { label: 'AED', value: 'AED' },
  { label: 'AFN', value: 'AFN' },
  { label: 'ALL', value: 'ALL' },
  { label: 'AMD', value: 'AMD' },
  { label: 'ANG', value: 'ANG' },
  { label: 'AOA', value: 'AOA' },
  { label: 'ARS', value: 'ARS' },
  { label: 'AWG', value: 'AWG' },
  { label: 'AZN', value: 'AZN' },
  { label: 'BAM', value: 'BAM' },
  { label: 'BBD', value: 'BBD' },
  { label: 'BDT', value: 'BDT' },
  { label: 'BGN', value: 'BGN' },
  { label: 'BHD', value: 'BHD' },
  { label: 'BIF', value: 'BIF' },
  { label: 'BMD', value: 'BMD' },
  { label: 'BND', value: 'BND' },
  { label: 'BOB', value: 'BOB' },
  { label: 'BRL', value: 'BRL' },
  { label: 'BSD', value: 'BSD' },
  { label: 'BTN', value: 'BTN' },
  { label: 'BWP', value: 'BWP' },
  { label: 'BYN', value: 'BYN' },
  { label: 'BZD', value: 'BZD' },
  { label: 'CAD', value: 'CAD' },
  { label: 'CDF', value: 'CDF' },
  { label: 'CHF', value: 'CHF' },
  { label: 'CLP', value: 'CLP' },
  { label: 'COP', value: 'COP' },
  { label: 'CRC', value: 'CRC' },
  { label: 'CUP', value: 'CUP' },
  { label: 'CVE', value: 'CVE' },
  { label: 'CZK', value: 'CZK' },
  { label: 'DJF', value: 'DJF' },
  { label: 'DKK', value: 'DKK' },
  { label: 'DOP', value: 'DOP' },
  { label: 'DZD', value: 'DZD' },
  { label: 'EGP', value: 'EGP' },
  { label: 'ERN', value: 'ERN' },
  { label: 'ETB', value: 'ETB' },
  { label: 'FJD', value: 'FJD' },
  { label: 'FKP', value: 'FKP' },
  { label: 'FOK', value: 'FOK' },
  { label: 'GEL', value: 'GEL' },
  { label: 'GGP', value: 'GGP' },
  { label: 'GHS', value: 'GHS' },
  { label: 'GIP', value: 'GIP' },
  { label: 'GMD', value: 'GMD' },
  { label: 'GNF', value: 'GNF' },
  { label: 'GTQ', value: 'GTQ' },
  { label: 'GYD', value: 'GYD' },
  { label: 'HNL', value: 'HNL' },
  { label: 'HRK', value: 'HRK' },
  { label: 'HTG', value: 'HTG' },
  { label: 'HUF', value: 'HUF' },
  { label: 'IDR', value: 'IDR' },
  { label: 'ILS', value: 'ILS' },
  { label: 'IMP', value: 'IMP' },
  { label: 'INR', value: 'INR' },
  { label: 'IQD', value: 'IQD' },
  { label: 'IRR', value: 'IRR' },
  { label: 'ISK', value: 'ISK' },
  { label: 'JEP', value: 'JEP' },
  { label: 'JMD', value: 'JMD' },
  { label: 'JOD', value: 'JOD' },
  { label: 'KES', value: 'KES' },
  { label: 'KGS', value: 'KGS' },
  { label: 'KHR', value: 'KHR' },
  { label: 'KID', value: 'KID' },
  { label: 'KMF', value: 'KMF' },
  { label: 'KWD', value: 'KWD' },
  { label: 'KYD', value: 'KYD' },
  { label: 'KZT', value: 'KZT' },
  { label: 'LAK', value: 'LAK' },
  { label: 'LBP', value: 'LBP' },
  { label: 'LKR', value: 'LKR' },
  { label: 'LRD', value: 'LRD' },
  { label: 'LSL', value: 'LSL' },
  { label: 'LYD', value: 'LYD' },
  { label: 'MAD', value: 'MAD' },
  { label: 'MDL', value: 'MDL' },
  { label: 'MGA', value: 'MGA' },
  { label: 'MKD', value: 'MKD' },
  { label: 'MMK', value: 'MMK' },
  { label: 'MNT', value: 'MNT' },
  { label: 'MOP', value: 'MOP' },
  { label: 'MRU', value: 'MRU' },
  { label: 'MUR', value: 'MUR' },
  { label: 'MVR', value: 'MVR' },
  { label: 'MWK', value: 'MWK' },
  { label: 'MXN', value: 'MXN' },
  { label: 'MYR', value: 'MYR' },
  { label: 'MZN', value: 'MZN' },
  { label: 'NAD', value: 'NAD' },
  { label: 'NGN', value: 'NGN' },
  { label: 'NIO', value: 'NIO' },
  { label: 'NOK', value: 'NOK' },
  { label: 'NPR', value: 'NPR' },
  { label: 'NZD', value: 'NZD' },
  { label: 'OMR', value: 'OMR' },
  { label: 'PAB', value: 'PAB' },
  { label: 'PEN', value: 'PEN' },
  { label: 'PGK', value: 'PGK' },
  { label: 'PHP', value: 'PHP' },
  { label: 'PKR', value: 'PKR' },
  { label: 'PLN', value: 'PLN' },
  { label: 'PYG', value: 'PYG' },
  { label: 'QAR', value: 'QAR' },
  { label: 'RON', value: 'RON' },
  { label: 'RSD', value: 'RSD' },
  { label: 'RUB', value: 'RUB' },
  { label: 'RWF', value: 'RWF' },
  { label: 'SAR', value: 'SAR' },
  { label: 'SBD', value: 'SBD' },
  { label: 'SCR', value: 'SCR' },
  { label: 'SDG', value: 'SDG' },
  { label: 'SEK', value: 'SEK' },
  { label: 'SHP', value: 'SHP' },
  { label: 'SLE', value: 'SLE' },
  { label: 'SLL', value: 'SLL' },
  { label: 'SOS', value: 'SOS' },
  { label: 'SRD', value: 'SRD' },
  { label: 'SSP', value: 'SSP' },
  { label: 'STN', value: 'STN' },
  { label: 'SYP', value: 'SYP' },
  { label: 'SZL', value: 'SZL' },
  { label: 'THB', value: 'THB' },
  { label: 'TJS', value: 'TJS' },
  { label: 'TMT', value: 'TMT' },
  { label: 'TND', value: 'TND' },
  { label: 'TOP', value: 'TOP' },
  { label: 'TRY', value: 'TRY' },
  { label: 'TTD', value: 'TTD' },
  { label: 'TVD', value: 'TVD' },
  { label: 'TWD', value: 'TWD' },
  { label: 'TZS', value: 'TZS' },
  { label: 'UAH', value: 'UAH' },
  { label: 'UGX', value: 'UGX' },
  { label: 'UYU', value: 'UYU' },
  { label: 'UZS', value: 'UZS' },
  { label: 'VES', value: 'VES' },
  { label: 'VND', value: 'VND' },
  { label: 'VUV', value: 'VUV' },
  { label: 'WST', value: 'WST' },
  { label: 'XAF', value: 'XAF' },
  { label: 'XCD', value: 'XCD' },
  { label: 'XDR', value: 'XDR' },
  { label: 'XOF', value: 'XOF' },
  { label: 'XPF', value: 'XPF' },
  { label: 'YER', value: 'YER' },
  { label: 'ZAR', value: 'ZAR' },
  { label: 'ZMW', value: 'ZMW' },
  { label: 'ZWL', value: 'ZWL' }
]

const scrollProduct = [
  [
    {
      color: '#EFEEC6',
      name: '睡衣',
      url: '/products?keyword=Pajama',
      id: '1009',
      src: require('@/assets/homePage/hot_1.png')
    },
    {
      color: '#CDF3E4',
      name: '书包',
      url: '/products?keyword=School%20Bag',
      id: '1441',
      src: require('@/assets/homePage/hot_2.png')
    },
    {
      color: '#D4BBE5',
      name: '棒球帽',
      url: '/products?keyword=Baseball%20cap',
      id: '1952',
      src: require('@/assets/homePage/hot_3.png')
    },
    {
      color: '#CDD6F3',
      name: '针织帽',
      url: '/products?keyword=Hat',
      id: '1691',
      src: require('@/assets/homePage/hot_4.png')
    },
    {
      color: '#D4BBE5',
      name: '懒人睡毯',
      url: '/products?keyword=Sleeper',
      id: '1649',
      src: require('@/assets/homePage/hot_5.png')
    }
  ],
  [
    {
      color: '#CDE1F3',
      name: '袜子',
      id: '2107',
      url: '/products?keyword=Socks',
      src: require('@/assets/homePage/hot_6.png')
    },
    {
      color: '#A9D4D6',
      name: '餐包',
      id: '1479',
      url: '/products?keyword=Lunch%20Bag',
      src: require('@/assets/homePage/hot_7.png')
    },
    {
      color: '#D6F3CD',
      name: '抱枕',
      id: '1922',
      url: '/products/category/decorative_pillows',
      src: require('@/assets/homePage/hot_8.png')
    },
    {
      color: '#CDF3E6',
      name: '连帽卫衣',
      id: '1575',
      url: '/products?keyword=Hoodie',
      src: require('@/assets/homePage/hot_9.png')
    },
    {
      color: '#CDD6F3',
      name: '毛毯',
      id: '2131',
      url: '/products?keyword=Blanket',
      src: require('@/assets/homePage/hot_10.png')
    }
  ],
  [
    {
      color: '#C6E4EF',
      name: '午餐包',
      id: '1324',
      url: '/products/category/lunch_bag',
      src: require('@/assets/homePage/hot_11.png')
    },
    {
      color: '#F3CDCD',
      name: '拼图',
      id: '1342',
      url: '/products?keyword=Puzzle',
      src: require('@/assets/homePage/hot_12.png')
    },
    {
      color: '#F3CDCD',
      name: '马克杯',
      url: '/products?keyword=Mug',
      id: '525',
      src: require('@/assets/homePage/hot_13.png')
    },
    {
      color: '#F3DFCD',
      name: 'T恤',
      url: '/products?keyword=T-Shirt',
      id: '1983',
      src: require('@/assets/homePage/hot_14.png')
    },
    {
      color: '#A9D4D6',
      name: '圣诞树裙',
      url: '/products?keyword=Tree%20Skirt',
      id: '964',
      src: require('@/assets/homePage/hot_15.png')
    }
  ],
  [
    {
      color: '#F5D2E9',
      name: '圣诞挂件',
      url: '/products?keyword=Christmas%20Ornament',
      id: '1517',
      src: require('@/assets/homePage/hot_16.png')
    },
    {
      color: '#A9D4D6',
      name: '手机壳',
      url: '/products/category/phone_cases',
      id: '1455',
      src: require('@/assets/homePage/hot_17.png')
    },
    {
      color: '#EFEEC6',
      name: '花园旗',
      url: '/products?keyword=Flag',
      id: '1374',
      src: require('@/assets/homePage/hot_18.png')
    },
    {
      color: '#CDF3E4',
      name: '蓝牙耳机',
      url: '/products?keyword=AirPods',
      id: '1979',
      src: require('@/assets/homePage/hot_19.png')
    },
    {
      color: '#CDF3E6',
      name: '挂件',
      url: '/products?keyword=Ornament',
      id: '1191',
      src: require('@/assets/homePage/hot_20.png')
    }
  ]
]

export {
  platformData,
  platformName,
  platformAll,
  platformMenu,
  languageData,
  languageKey,
  keyCodeData,
  whenMade,
  thirdProductUnit,
  mapChinese,
  applyPlatform,
  qualityLevel,
  curList,
  scrollProduct
}
